(() => {
  'use strict';
  const el = document.getElementById('PcCountryConfig');
  if (!el) return;
  const cfg = JSON.parse(el.textContent);
  const html = document.documentElement;
  const preview = window.Shopify?.theme?.role === 'unpublished';
  const store = {
    get(k) { try { return sessionStorage.getItem('pc-country-' + k); } catch { return null; } },
    set(k, v) { try { sessionStorage.setItem('pc-country-' + k, v); } catch {} },
    remove(k) { try { sessionStorage.removeItem('pc-country-' + k); } catch {} }
  };
  const valid = v => typeof v === 'string' && /^[A-Z]{2}$/.test(v);
  const url = new URL(location.href);
  const parameter = url.searchParams.get('pc_country');
  if (preview && parameter === 'auto') store.remove('test');
  else if (preview && ['DE', 'NL', 'IT', 'AT', 'FR', 'ES', 'PL'].includes(parameter)) store.set('test', parameter);
  const forced = preview ? store.get('test') : null;
  const state = {market: cfg.country, detected: null, selected: null, source: '', error: ''};
  let bar;
  function renderStatus() {
    if (!bar) return;
    bar.querySelector('output').textContent = `Ansicht: ${state.selected || '…'} · Shopify-Markt: ${state.market} · Ländererkennung: ${state.detected || 'nicht ermittelt'} · ${state.source}${state.error ? ' · ' + state.error : ''}`;
  }
  if (preview && cfg.testbar) {
    bar = document.createElement('details');
    bar.className = 'pc-testbar';
    bar.open = true;
    bar.innerHTML = '<summary>Nur Entwurf: Länderansicht testen</summary><label>Testland <select aria-label="Testland"><option value="auto">Automatische Zuordnung</option><option value="DE">Deutschland – Anfrage</option><option value="NL">Niederlande – Anfrage</option><option value="IT">Italien – Verkauf</option><option value="AT">Österreich – Verkauf</option><option value="FR">Frankreich – Verkauf</option><option value="ES">Spanien – Verkauf</option><option value="PL">Polen – Verkauf</option></select></label><output aria-live="polite"></output><p>Darstellungstest, keine technische Preissperre. Classical Pearls: Informationen weltweit öffentlich; Preise und Bestellung nur nach persönlicher Fachkundenfreigabe, kein Direktverkauf im Shop. Die Testauswahl ändert nur diese Browser-Sitzung.</p>';
    document.querySelector('main')?.before(bar);
    bar.querySelector('select').value = forced || 'auto';
    bar.querySelector('select').addEventListener('change', e => {
      const next = new URL(location.href);
      next.searchParams.set('pc_country', e.target.value);
      location.assign(next.href);
    });
  }
  function apply(country, source) {
    state.selected = country;
    state.source = source;
    html.dataset.pcView = cfg.enabled !== false && (!valid(country) || ['DE', 'NL'].includes(country)) ? 'restricted' : 'open';
    html.dataset.pcPending = 'false';
    html.dataset.pcCountry = country || '';
    html.dataset.pcSource = source;
    renderStatus();
  }
  function alignMarket(country) {
    if (!valid(country) || country === cfg.country || country === 'NL' || !cfg.countries.includes(country)) return false;
    const key = `${cfg.country}-${country}`;
    if (store.get('alignment') === key) {
      state.error = 'Marktwechsel nicht bestätigt; Preise gehören zum angezeigten Shopify-Markt';
      return false;
    }
    store.set('alignment', key);
    state.source = 'Passenden Shopify-Markt laden …';
    renderStatus();
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = new URL('localization', location.origin + '/').href;
    form.hidden = true;
    const returnTo = location.pathname + location.search + location.hash;
    for (const [name, value] of Object.entries({form_type:'localization', _method:'put', country_code:country, return_to:returnTo})) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      form.append(input);
    }
    document.body.append(form);
    form.submit();
    return true;
  }
  async function init() {
    if (cfg.enabled === false) { apply(cfg.country, 'Darstellungsschalter aus'); return; }
    if (forced) {
      state.selected = forced;
      if (alignMarket(forced)) return;
      apply(forced, 'Simulation im Entwurf – kein IP-Test');
      return;
    }
    if (cfg.detection === 'market') { apply(cfg.country, 'Shopify-Markt'); return; }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3500);
    try {
      const root = cfg.root.endsWith('/') ? cfg.root : cfg.root + '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {credentials:'same-origin', signal:controller.signal});
      if (!response.ok) throw Error('Ländererkennung nicht verfügbar');
      const data = await response.json();
      const detected = data.detected_values?.country?.handle;
      if (!valid(detected)) throw Error('Kein erkanntes Land zurückgegeben');
      state.detected = detected;
      state.selected = detected;
      if (alignMarket(detected)) return;
      apply(detected, 'Shopify-Ländererkennung');
    } catch {
      state.error = 'Erkennung nicht verfügbar – Rückfall auf Shopify-Markt';
      apply(cfg.country, 'Rückfall');
    } finally { clearTimeout(timeout); }
  }
  document.addEventListener('submit', event => {
    if (html.dataset.pcView !== 'restricted') return;
    const form = event.target;
    if (form.closest('[data-pc-display="open"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  init();
})();
